// import { Button } from '@vadiun/react-components'
import PageHeader from 'layout/components/PageHeader';
import React, { useRef, useState } from 'react';
import { CREATE, TABLE } from '../../../../shared/constans';
import PageContainer from 'layout/components/PageContainer';
import AppUsersTable from '../components/AppUsersTable';

import { Role, User } from '../models/appUsersModels';
import ChangeActiveStatusModal from '../components/ChangeActiveStatusModal';
import { createTableScrollHandler } from 'utils/tableUtils';
import { Button } from '@vadiun/react-components';
import UserAppClientCreate from 'app/client/appUsers/components/userAppClient/UserAppClientCreate';
import { useAppUser } from '../hook/useAppUser';
import {
  BackEndDomicilio,
  PayLoadAddCorporateUser,
  PayLoadAddParticularUser,
  UserFormValues
} from '../models/appUserModel';
import { domicilioBuilder } from 'app/domicilio/models/DomicilioModel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import DownloadExcelModal from 'shared/components/userApp/DownLoadExcelModal';
import { appUsersService } from '../services/appUsersService';

const AppUsers = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const [visiblePage, setVisiblePage] = useState(TABLE);
  const [userSelected, setUserSelected] = useState<User | undefined>(undefined);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openDownloadExcel, setOpenDownloadExcel] = useState(false);

  const {
    appUsers,
    totalItems,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSearchChange,
    handleSortChange,
    handleUserTypeChange,
    userType,
    addCorporateMutation,
    addParticularMutation,
    changeActiveStatus,
    reload,
    deleteAppUser,
    loadingDeleteAppUser,
  } = useAppUser();

  const AppUsersService = appUsersService();
  const handleActivationAction = (user: User) => {
    setUserSelected(user);
    setIsModalOpen(true);
  };

  const handleChangeVerification = async (
    userId: string,
    isActive: boolean,
    authorizedId: number | null
  ) => {
    try {
      await changeActiveStatus.mutate(
        userId,
        isActive,
        authorizedId === 0 ? null : authorizedId
      );
    } catch (error) {
      console.error('Error al cambiar el estado activo:', error);
    } finally {
      reload();
    }
  };

  const createUserApp = async (values: UserFormValues) => {
    if (values.role === Role.CORPORATE) {
      const payload: PayLoadAddCorporateUser = {
        fullname: values.fullname!!,
        email: values.email,
        phone: values.phone!,
        company_id: values.company!.company_id
      };
      await addCorporateMutation.mutate(payload);
    } else {
      const payload: PayLoadAddParticularUser = {
        first_name: values.first_name!!,
        last_name: values.last_name!!,
        email: values.email,
        phone_number_one: values.phone || '',
        alias: values.alias || '',
        address:
          values.address?.latitud && values.address.latitud !== 0
            ? (domicilioBuilder.toBackEnd(values.address) as BackEndDomicilio)
            : undefined
      };
      await addParticularMutation.mutate(payload);
    }
    setVisiblePage(TABLE);
  };

  const handleDownloadExcel = async (values: any) => {
    try {
      const response = await (AppUsersService.downloadExcel(values) as unknown as Promise<{ data: number[] }>);

      if (!response || !response.data) {
        console.error("La respuesta no contiene datos");
        return;
      }

      const byteArray = new Uint8Array(response.data);

      const blob = new Blob([byteArray], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `informe-usuarios-app.xlsx`);
      document.body.appendChild(link);
      link.click();

      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);
      setOpenDownloadExcel(false);
    } catch (error) {
      console.error('Error al descargar excel:', error);
    }
  }

  return (
    <div ref={tableRef}>
      <PageHeader
        area="Comercial - Gestión de Clientes"
        title="Empresa"
        subArea={
          visiblePage === TABLE
            ? 'Tabla de usuarios de app'
            : 'Nuevo usuario de app'
        }
        toolbar={
          <div className="flex gap-x-2">
            <Button onClick={() => setOpenDownloadExcel(true)} variant="outlined">
              <div className="flex gap-x-2 items-center">
                <FontAwesomeIcon icon={faDownload} />
                Descargar Informe
              </div>
            </Button>
            {visiblePage === TABLE ? (
              <Button onClick={() => setVisiblePage(CREATE)} variant="light">
                Crear Cliente
              </Button>
            ) : (
              <Button onClick={() => setVisiblePage(TABLE)} variant="light">
                Volver
              </Button>
            )}
          </div>
        }
      />
      <PageContainer>
        {visiblePage === TABLE && (
          <AppUsersTable
            handlePageChange={createTableScrollHandler(tableRef)}
            users={appUsers}
            totalItems={totalItems}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPage={rowsPerPage}
            activationAction={handleActivationAction}
            onSearchChange={handleSearchChange}
            onSortChange={handleSortChange}
            onUserTypeChange={handleUserTypeChange}
            activeUserType={userType}
            onDeleteUser={deleteAppUser}
            loadingDeleteAppUser={loadingDeleteAppUser}
            reload={reload}
          />
        )}
        {visiblePage === CREATE && (
          <UserAppClientCreate
            setVisiblePage={setVisiblePage}
            createUserApp={createUserApp}
          />
        )}
      </PageContainer>

      {userSelected && (
        <ChangeActiveStatusModal
          user={userSelected!}
          isOpen={isModalOpen}
          handleClose={() => setIsModalOpen(false)}
          changeVerification={handleChangeVerification}
        />
      )}
         {openDownloadExcel && (
        <DownloadExcelModal
          isOpen={openDownloadExcel}
          onClose={() => setOpenDownloadExcel(false)}
          onSubmit={handleDownloadExcel}
        />
      )}
    </div>
  );
};

export default AppUsers;
